import * as i0 from '@angular/core';
import { ViewContainerRef, TemplateRef, Component, ViewChild, Input, NgModule } from '@angular/core';
import * as i3 from 'abs-ngx-library/src/lib/core';
import { EnviormentConfig } from 'abs-ngx-library/src/lib/core';
import * as i1 from 'abs-ngx-library/src/lib/product-generic-grid';
import { ProductGenericGridModule } from 'abs-ngx-library/src/lib/product-generic-grid';
import * as i2 from '@angular/common/http';
import * as i4 from '@angular/common';
import { CommonModule } from '@angular/common';

/**
 *
 * @template
 */
const _c0 = ["qualifiedProductsContainer"];
const _c1 = ["productGridTemplate"];
function OfferQualifiedProductsALV1Component_product_generic_grid_al_v1_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "product-generic-grid-al-v1", 3);
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("objGridData", ctx_r0.objGridData)("dataValue", ctx_r0.dataValue)("calledBy", ctx_r0.triggerBy)("qualifiedProducts", ctx_r0.JSONqualifiedProductsResponse)("configObj", ctx_r0.configObj);
} }
function OfferQualifiedProductsALV1Component_product_generic_grid_al_v1_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "product-generic-grid-al-v1", 3);
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("objGridData", ctx_r0.objGridData)("dataValue", ctx_r0.dataValue)("calledBy", ctx_r0.triggerBy)("qualifiedProducts", ctx_r0.JSONqualifiedProductsResponse)("configObj", ctx_r0.configObj);
} }
function OfferQualifiedProductsALV1Component_ng_container_4_ul_3_Template(rf, ctx) { if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ul", 11)(1, "li", 12)(2, "a", 13);
    i0.ɵɵlistener("click", function OfferQualifiedProductsALV1Component_ng_container_4_ul_3_Template_a_click_2_listener($event) { i0.ɵɵrestoreView(_r2); const ctx_r0 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r0.handleTab(false, $event)); });
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(4, "li", 12)(5, "a", 14);
    i0.ɵɵlistener("click", function OfferQualifiedProductsALV1Component_ng_container_4_ul_3_Template_a_click_5_listener($event) { i0.ɵɵrestoreView(_r2); const ctx_r0 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r0.handleTab(true, $event)); });
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵattributeInterpolate1("aria-label", "Eligible to buy (", ctx_r0.upcList.length, ") product");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" Eligible to buy (", ctx_r0.upcList.length, ") ");
    i0.ɵɵadvance(2);
    i0.ɵɵattributeInterpolate1("aria-label", "Eligible to get (", ctx_r0.eligibleUpcList.length, ") product");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" Eligible to get (", ctx_r0.eligibleUpcList.length, ") ");
} }
function OfferQualifiedProductsALV1Component_ng_container_4_product_generic_grid_al_v1_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "product-generic-grid-al-v1", 3);
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("objGridData", ctx_r0.objGridData)("dataValue", ctx_r0.dataValue)("calledBy", ctx_r0.triggerBy)("qualifiedProducts", ctx_r0.JSONqualifiedProductsResponse)("configObj", ctx_r0.configObj);
} }
function OfferQualifiedProductsALV1Component_ng_container_4_product_generic_grid_al_v1_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "product-generic-grid-al-v1", 3);
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("objGridData", ctx_r0.objGridData)("dataValue", ctx_r0.dataValue)("calledBy", ctx_r0.triggerBy)("qualifiedProducts", ctx_r0.eligibleJSONqualifiedProductsResponse)("configObj", ctx_r0.configObj);
} }
function OfferQualifiedProductsALV1Component_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 4)(2, "div", 5);
    i0.ɵɵtemplate(3, OfferQualifiedProductsALV1Component_ng_container_4_ul_3_Template, 7, 6, "ul", 6);
    i0.ɵɵelement(4, "div", 7);
    i0.ɵɵelementStart(5, "div", 8)(6, "div", 9);
    i0.ɵɵtemplate(7, OfferQualifiedProductsALV1Component_ng_container_4_product_generic_grid_al_v1_7_Template, 1, 5, "product-generic-grid-al-v1", 1);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "div", 10);
    i0.ɵɵtemplate(9, OfferQualifiedProductsALV1Component_ng_container_4_product_generic_grid_al_v1_9_Template, 1, 5, "product-generic-grid-al-v1", 1);
    i0.ɵɵelementEnd()()()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r0.upcList.length && ctx_r0.eligibleUpcList.length);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", ctx_r0.showGrid);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.showGrid && ctx_r0.eligibleJSONqualifiedProductsResponse.length);
} }
class OfferQualifiedProductsALV1Component {
    constructor(_productGridService, _http, zone, elementRef, _zone, _abTestService, _commonService, _userInfoService, _utilService, _cartService) {
        this._productGridService = _productGridService;
        this._http = _http;
        this.elementRef = elementRef;
        this._zone = _zone;
        this._abTestService = _abTestService;
        this._commonService = _commonService;
        this._userInfoService = _userInfoService;
        this._utilService = _utilService;
        this._cartService = _cartService;
        this.offer = {};
        this.isBXGYEligibleOffer = false;
        this.config = EnviormentConfig;
        this.ack = true;
        this.objGridData = {
            drivenType: '',
            apiUrl: '',
            apiType: '',
            sorts: '',
            defaultSort: '',
            value: {},
            products: [],
            widgetId: '',
            load_type: '',
            infinite_type: '',
            doGenericFlow: false,
            modelConfigurationId: ''
        };
        this.triggerBy = '';
        this.eligibleJSONqualifiedProductsResponse = [];
        this.upcList = [];
        this.eligibleUpcList = [];
        this.isEligibleUpcListTabSelected = false;
        const currentComponent = this.elementRef.nativeElement;
        const attributes = currentComponent && currentComponent.attributes;
        this.productGridPage = attributes['data-driven'] ? attributes['data-driven'].value : "catalog";
        const defaultSort = attributes['data-default-sorts'] ? attributes['data-default-sorts'].value : undefined;
        const dataApiType = attributes['data-api-type'] ? attributes['data-api-type'].value : 'c-products-by-upc-drawer';
        this.objGridData = {
            drivenType: dataApiType == 's-bogo' ? 'static' : this.productGridPage,
            apiUrl: attributes['data-api-url'] && attributes['data-api-url'].value,
            apiType: dataApiType,
            sorts: attributes['data-sorts'] && attributes['data-sorts'].value,
            defaultSort,
            value: {},
            products: [],
            widgetId: attributes['data-widget-id'] && attributes['data-widget-id'].value,
            load_type: attributes['data-load-type'] ? attributes['data-load-type'].value : 'loadmore',
            infinite_type: attributes['data-infinite-scroll-type'] ? attributes['data-infinite-scroll-type'].value : 'client',
            doGenericFlow: attributes['data-dogeneric-flow'] ? attributes['data-dogeneric-flow'].value == "true" : false,
        };
        if (this.objGridData.doGenericFlow && this.objGridData.drivenType == 'generic') {
            this.objGridData.modelConfigurationId = this.getModelConfigIdFromUrl();
            let genericTitleElement = document.getElementById('genericGridTitle');
            let genericTitleText = new URLSearchParams(window.location.search).get('title');
            if (genericTitleElement && genericTitleText) {
                genericTitleElement.innerHTML = genericTitleText;
            }
        }
        this.triggerBy = this.productGridPage;
        if (this.productGridPage === 'purchase' || this.productGridPage === 'catalog' || this.productGridPage === 'static') {
            this.triggerBy = this.objGridData.apiType;
        }
        try {
            let strValue = this.dataValue;
            if (this.dataValue === undefined) {
                strValue = this.elementRef.nativeElement.getAttribute('data-value');
            }
            strValue = strValue.replace(/'/g, '"');
            this.objGridData.value = JSON.parse(strValue);
        }
        catch (e) {
            // silent. objGridData.value has default value
        }
        if (this.objGridData.apiType === 'c-products-by-upc-drawer') {
            this.currentEnv = this._commonService.getCurrentEnviorment();
            const catalogConfig = this.config[this.currentEnv].catalogConfig;
            this.objGridData.apiUrl = catalogConfig["apim.api.catalog.path"] + catalogConfig["apim.api.catalog.product.upc.endpoint"];
        }
        if (this.productGridPage === 'static') {
            this.objGridData.products = this.staticProducts;
        }
        this.showGrid = false;
    }
    ngOnInit() {
        if (!this.configObj) {
            this.configObj = {
                programType: 'abs'
            };
        }
        try {
            let strValue = this.dataValue;
            if (this.dataValue === undefined) {
                strValue = this.elementRef.nativeElement.getAttribute('data-value');
            }
            strValue = strValue.replace(/'/g, '"');
            this.objGridData.value = JSON.parse(strValue);
        }
        catch (e) {
            // silent. objGridData.value has default value
        }
        this._commonService._userInfoRefresh.subscribe(data => {
            if (data === 'initFunc') {
                if (this.configObj && this.configObj.bannerDomain) {
                    this.objGridData.apiUrl = this.configObj.bannerDomain + this.objGridData.apiUrl;
                }
                this._productGridService.objGridData = this.objGridData;
                // assign products info to objGridData for static data
                if (this.productGridPage === 'static') {
                    this.objGridData.products = this.staticProducts;
                }
                // get products to populate in product grid
                this.getProduct();
                this.setProgramTypeFromBannerTypeMetaTag();
                this._cartService.rightDrawerEvent.next({
                    'event': 'openOfferDetails',
                    'data': []
                });
            }
        });
        this._commonService.$bxgyOffer.subscribe(offer => {
            this.upcList = offer?.upcList || [];
            this.eligibleUpcList = offer?.eligibleUpcList || [];
        });
    }
    getProduct() {
        this._productGridService.getData().subscribe((data) => {
            if (this.productGridPage !== 'static' && this.objGridData.drivenType !== 'generic') {
                data.products = this.configObj && this.configObj.appName && this.configObj.appName === 'weeklyAd' && data['response'] && data['response']['docs'] && data['response']['docs'].length > 0
                    ? data['response']['docs'].filter(pdt => !pdt.isMtoProduct)
                    : data['response']['docs'];
            }
            data.ack = false;
            this.qualifiedProductsResponse = data;
            if (this.isEligibleUpcListTabSelected) {
                this.eligibleJSONqualifiedProductsResponse = this.getQualifiedProductsJson(this.qualifiedProductsResponse);
            }
            else {
                this.JSONqualifiedProductsResponse = this.getQualifiedProductsJson(this.qualifiedProductsResponse);
            }
            this.showGrid = true;
        }, (err) => {
            //
        });
    }
    getQualifiedProductsJson(productsData) {
        let jsonProducts = '{}';
        if (productsData && productsData.products) {
            jsonProducts = JSON.stringify(productsData);
        }
        return jsonProducts;
    }
    /**
    * Set programType value from BannerType Meta tag Content
    */
    setProgramTypeFromBannerTypeMetaTag() {
        const isB2BSite = this._userInfoService?.getSiteType() === "B";
        if (isB2BSite) {
            const bannerTypeContent = $("meta[name='bannerType']").attr("content");
            this.configObj.programType = bannerTypeContent;
        }
    }
    getModelConfigIdFromUrl() {
        try {
            return window.location.pathname.substring(1).split('/')[2];
        }
        catch (e) {
            return '';
        }
    }
    /**
    *
    * Set the selected tab for BXGY offer and call the API to get the eligible products only first time
    */
    handleTab(isEligibleUpcList, event) {
        event.preventDefault();
        this.isEligibleUpcListTabSelected = isEligibleUpcList;
        if (isEligibleUpcList && !this.eligibleJSONqualifiedProductsResponse.length) {
            this.getProduct();
            this._commonService.upcs.next(this.eligibleUpcList);
        }
    }
    static { this.ɵfac = function OfferQualifiedProductsALV1Component_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || OfferQualifiedProductsALV1Component)(i0.ɵɵdirectiveInject(i1.ProductGenericGridALV1Service), i0.ɵɵdirectiveInject(i2.HttpClient), i0.ɵɵdirectiveInject(i0.NgZone), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone), i0.ɵɵdirectiveInject(i3.ABTestService), i0.ɵɵdirectiveInject(i3.CommonService), i0.ɵɵdirectiveInject(i3.UserInfoService), i0.ɵɵdirectiveInject(i3.UtilService), i0.ɵɵdirectiveInject(i3.CartService)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: OfferQualifiedProductsALV1Component, selectors: [["offer-qualified-products-al-v1"]], viewQuery: function OfferQualifiedProductsALV1Component_Query(rf, ctx) { if (rf & 1) {
            i0.ɵɵviewQuery(_c0, 7, ViewContainerRef);
            i0.ɵɵviewQuery(_c1, 7, TemplateRef);
        } if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.qualifiedProductsContainer = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.productGridTemplate = _t.first);
        } }, inputs: { dataValue: "dataValue", staticProducts: "staticProducts", configObj: "configObj", offer: "offer", isBXGYEligibleOffer: "isBXGYEligibleOffer" }, decls: 5, vars: 3, consts: [["qualifiedProductsContainer", ""], ["data-infinite-scroll-type", "client", "data-load-type", "loadmore", "data-load-more-mobile-items", "10", "data-load-more-tablet-items", "10", "data-load-more-desktop-items", "10", 3, "objGridData", "dataValue", "calledBy", "qualifiedProducts", "configObj", 4, "ngIf"], [4, "ngIf"], ["data-infinite-scroll-type", "client", "data-load-type", "loadmore", "data-load-more-mobile-items", "10", "data-load-more-tablet-items", "10", "data-load-more-desktop-items", "10", 3, "objGridData", "dataValue", "calledBy", "qualifiedProducts", "configObj"], [1, "product-wrapper-v2", "product-wrapper-v2--details", "section", "mt-0"], ["role", "region", "aria-label", "Section for Eligible to buy, Eligible to get", 1, "product-tabs", "mt-0"], ["class", "nav product-tabs__nav", "role", "tablist", "aria-orientation", "horizontal", 4, "ngIf"], [1, "product-tabs__bar"], [1, "tab-content", "product-tabs__content"], ["id", "eligibleToBuy", "tabindex", "0", 1, "tab-pane", "fade", "show", "active", "body-text"], ["id", "eligibleToGet", "tabindex", "0", 1, "tab-pane", "fade", "body-text"], ["role", "tablist", "aria-orientation", "horizontal", 1, "nav", "product-tabs__nav"], ["role", "presentation", 1, "product-tabs__nav__item", "text-center", "w-50", "p-0", "pt-3", "pb-3"], ["href", "#eligibleToBuy", "data-toggle", "tab", "role", "tab", "aria-controls", "eligibleToBuy", 1, "title-xs", "active", 3, "click"], ["href", "#eligibleToGet", "data-toggle", "tab", "role", "tab", "aria-controls", "eligibleToGet", 1, "title-xs", 3, "click"]], template: function OfferQualifiedProductsALV1Component_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementContainer(0, null, 0);
            i0.ɵɵtemplate(2, OfferQualifiedProductsALV1Component_product_generic_grid_al_v1_2_Template, 1, 5, "product-generic-grid-al-v1", 1)(3, OfferQualifiedProductsALV1Component_product_generic_grid_al_v1_3_Template, 1, 5, "product-generic-grid-al-v1", 1)(4, OfferQualifiedProductsALV1Component_ng_container_4_Template, 10, 3, "ng-container", 2);
        } if (rf & 2) {
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.showGrid && ctx.objGridData.apiType !== "s-bogo" && !ctx.isBXGYEligibleOffer);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.showGrid && ctx.objGridData.apiType === "s-bogo" && !ctx.isBXGYEligibleOffer);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.isBXGYEligibleOffer);
        } }, dependencies: [i4.NgIf, i1.ProductGenericGridALV1Component], encapsulation: 2 }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(OfferQualifiedProductsALV1Component, [{
        type: Component,
        args: [{ selector: 'offer-qualified-products-al-v1', template: "<ng-container #qualifiedProductsContainer></ng-container>\n\n<product-generic-grid-al-v1 *ngIf=\"showGrid && objGridData.apiType !== 's-bogo' && !isBXGYEligibleOffer\"\n    data-infinite-scroll-type=\"client\"\n    data-load-type=\"loadmore\"\n    data-load-more-mobile-items=\"10\"\n    data-load-more-tablet-items=\"10\"\n    data-load-more-desktop-items=\"10\"\n    [objGridData]=\"objGridData\"\n    [dataValue]=\"dataValue\"\n    [calledBy]=\"triggerBy\"\n    [qualifiedProducts]=\"JSONqualifiedProductsResponse\"\n    [configObj]=\"configObj\">\n</product-generic-grid-al-v1>\n\n<product-generic-grid-al-v1 *ngIf=\"showGrid && objGridData.apiType === 's-bogo' && !isBXGYEligibleOffer\"\n    data-infinite-scroll-type=\"client\"\n    data-load-type=\"loadmore\"\n    data-load-more-mobile-items=\"10\"\n    data-load-more-tablet-items=\"10\"\n    data-load-more-desktop-items=\"10\"\n    [objGridData]=\"objGridData\"\n    [dataValue]=\"dataValue\"\n    [calledBy]=\"triggerBy\"\n    [qualifiedProducts]=\"JSONqualifiedProductsResponse\"\n    [configObj]=\"configObj\">\n</product-generic-grid-al-v1>\n\n<ng-container *ngIf=\"isBXGYEligibleOffer\">\n    <div class=\"product-wrapper-v2 product-wrapper-v2--details section mt-0\">\n        <div class=\"product-tabs mt-0\" role=\"region\" aria-label=\"Section for Eligible to buy, Eligible to get\">\n            <ul *ngIf=\"upcList.length && eligibleUpcList.length\" class=\"nav product-tabs__nav\" role=\"tablist\" aria-orientation=\"horizontal\">\n                <li class=\"product-tabs__nav__item text-center w-50 p-0 pt-3 pb-3\" role=\"presentation\">\n                    <a href=\"#eligibleToBuy\" data-toggle=\"tab\" role=\"tab\" aria-controls=\"eligibleToBuy\" (click)=\"handleTab(false, $event)\" class=\"title-xs active\" attr.aria-label=\"Eligible to buy ({{upcList.length}}) product\">\n                        Eligible to buy ({{upcList.length}})\n                    </a>\n                </li>\n                <li class=\"product-tabs__nav__item text-center w-50 p-0 pt-3 pb-3\" role=\"presentation\">\n                    <a href=\"#eligibleToGet\" data-toggle=\"tab\" role=\"tab\" aria-controls=\"eligibleToGet\" (click)=\"handleTab(true, $event)\" class=\"title-xs\" attr.aria-label=\"Eligible to get ({{eligibleUpcList.length}}) product\">\n                        Eligible to get ({{eligibleUpcList.length}})\n                    </a>\n                </li>\n            </ul>\n\n            <div class=\"product-tabs__bar\"></div>\n            <div class=\"tab-content product-tabs__content\">\n                <div class=\"tab-pane fade show active body-text\" id=\"eligibleToBuy\" tabindex=\"0\">\n                    <product-generic-grid-al-v1 *ngIf=\"showGrid\"\n                                                data-infinite-scroll-type=\"client\"\n                                                data-load-type=\"loadmore\"\n                                                data-load-more-mobile-items=\"10\"\n                                                data-load-more-tablet-items=\"10\"\n                                                data-load-more-desktop-items=\"10\"\n                                                [objGridData]=\"objGridData\"\n                                                [dataValue]=\"dataValue\"\n                                                [calledBy]=\"triggerBy\"\n                                                [qualifiedProducts]=\"JSONqualifiedProductsResponse\"\n                                                [configObj]=\"configObj\">\n                    </product-generic-grid-al-v1>\n                </div>\n                <div class=\"tab-pane fade body-text\" id=\"eligibleToGet\" tabindex=\"0\">\n                    <product-generic-grid-al-v1 *ngIf=\"showGrid && eligibleJSONqualifiedProductsResponse.length\"\n                                                data-infinite-scroll-type=\"client\"\n                                                data-load-type=\"loadmore\"\n                                                data-load-more-mobile-items=\"10\"\n                                                data-load-more-tablet-items=\"10\"\n                                                data-load-more-desktop-items=\"10\"\n                                                [objGridData]=\"objGridData\"\n                                                [dataValue]=\"dataValue\"\n                                                [calledBy]=\"triggerBy\"\n                                                [qualifiedProducts]=\"eligibleJSONqualifiedProductsResponse\"\n                                                [configObj]=\"configObj\">\n                    </product-generic-grid-al-v1>\n                </div>\n            </div>\n        </div>\n    </div>\n</ng-container>\n" }]
    }], () => [{ type: i1.ProductGenericGridALV1Service }, { type: i2.HttpClient }, { type: i0.NgZone }, { type: i0.ElementRef }, { type: i0.NgZone }, { type: i3.ABTestService }, { type: i3.CommonService }, { type: i3.UserInfoService }, { type: i3.UtilService }, { type: i3.CartService }], { qualifiedProductsContainer: [{
            type: ViewChild,
            args: ['qualifiedProductsContainer', { read: ViewContainerRef, static: true }]
        }], productGridTemplate: [{
            type: ViewChild,
            args: ['productGridTemplate', { read: TemplateRef, static: true }]
        }], dataValue: [{
            type: Input
        }], staticProducts: [{
            type: Input
        }], configObj: [{
            type: Input
        }], offer: [{
            type: Input,
            args: ['offer']
        }], isBXGYEligibleOffer: [{
            type: Input,
            args: ['isBXGYEligibleOffer']
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(OfferQualifiedProductsALV1Component, { className: "OfferQualifiedProductsALV1Component", filePath: "offer-qualified-products-al-v1/offer-qualified-products-al-v1.component.ts", lineNumber: 34 }); })();

class OfferQualifiedProductsModule {
    static { this.ɵfac = function OfferQualifiedProductsModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || OfferQualifiedProductsModule)(); }; }
    static { this.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: OfferQualifiedProductsModule }); }
    static { this.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ providers: [
            OfferQualifiedProductsALV1Component,
        ], imports: [CommonModule,
            ProductGenericGridModule] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(OfferQualifiedProductsModule, [{
        type: NgModule,
        args: [{
                declarations: [OfferQualifiedProductsALV1Component],
                exports: [
                    OfferQualifiedProductsALV1Component,
                ],
                imports: [
                    CommonModule,
                    ProductGenericGridModule
                ],
                providers: [
                    OfferQualifiedProductsALV1Component,
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(OfferQualifiedProductsModule, { declarations: [OfferQualifiedProductsALV1Component], imports: [CommonModule,
        ProductGenericGridModule], exports: [OfferQualifiedProductsALV1Component] }); })();

// //Component

/**
 * Generated bundle index. Do not edit.
 */

export { OfferQualifiedProductsALV1Component, OfferQualifiedProductsModule };
